import { render, staticRenderFns } from "./EditUserDictionary.vue?vue&type=template&id=4519188e&scoped=true&"
import script from "./EditUserDictionary.vue?vue&type=script&lang=js&"
export * from "./EditUserDictionary.vue?vue&type=script&lang=js&"
import style0 from "./EditUserDictionary.vue?vue&type=style&index=0&id=4519188e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519188e",
  null
  
)

export default component.exports